<div class="tooltip-wrapper">
  <div #tooltip [hidden]="true" class="tooltip">
      <mpro-tooltip [options]="tooltipOptions"></mpro-tooltip>
  </div>
</div>

<figure [id]="chartId"></figure>
